import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from "@ng-select/ng-select";
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SurveyComponent } from './pages/survey/survey.component';
import { SupplierAuthComponent } from './pages/supplier-auth/supplier-auth.component';
import { ThankyouComponent } from './pages/thankyou/thankyou.component';
import { HomeComponent } from './pages/home/home.component';
import { CaptchaComponent } from './pages/captcha/captcha.component';
import { TextanalyzerComponent } from './pages/textanalyzer/textanalyzer.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SurveyStatusComponent } from './pages/survey-status/survey-status.component';
import { LanguageComponent } from './pages/language/language.component';
import { AffiliatePreScreen } from './pages/affiliate-prescreen/affiliate-prescreen.component';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';


@NgModule({
  declarations: [
    AppComponent,
    SurveyComponent,
    SupplierAuthComponent,
    ThankyouComponent,
    HomeComponent,
    NotFoundComponent,
    CaptchaComponent,
    TextanalyzerComponent,
    SurveyStatusComponent,
    LanguageComponent,
    AffiliatePreScreen
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgOtpInputModule,
    FormsModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    RouterModule,
    ReactiveFormsModule,
    NgxCaptchaModule,
    NgSelectModule
  ],
  providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } },],
  bootstrap: [AppComponent]
})
export class AppModule { }
